import { Icon, spinner } from '../../components/Icon/Icon';
import { ApiOrder } from '../../types';
import { useFormatting, useTranslation } from '../../i18n/i18n';
import { UiContainer } from '../../state/ui';
import { Table } from '../Table/Table';
import { useDefaultVatMultiplier } from '../../utils/vatUtils';
import './EditOrderTotalsTable.css';

export const EditOrderTotalsTable = ({
	order,
	totalsLoading,
}: {
	order: ApiOrder;
	totalsLoading: boolean;
}): JSX.Element | null => {
	const t = useTranslation().cart;
	const { asPrice } = useFormatting();
	const ui = UiContainer.useContainer();
	const vatMultiplier = useDefaultVatMultiplier(ui.priceWithVat);
	const { totals } = order;
	const { subTotal, subTotalVat, shippingFee, discount, vat, total, letterFee, notificationFee } = totals;

	if (order.items.length === 0) return null;

	return (
		<div className="edit-order-totals" style={totalsLoading ? { color: 'grey' } : {}}>
			<Table
				loaderIcon={
					<div
						style={totalsLoading ? { visibility: 'visible' } : { visibility: 'hidden' }}
						className="spinner-wrapper"
					>
						<Icon shape={spinner} size={44} />
					</div>
				}
			>
				<tbody>
					<tr>
						<td>{t.subTotal}</td>
						<td className="text-right">{asPrice(subTotal + (ui.priceWithVat ? subTotalVat : 0))}</td>
					</tr>
					<tr>
						<td>{t.delivery}</td>
						<td className="text-right">{asPrice(shippingFee * vatMultiplier)}</td>
					</tr>
					{discount < 0 && (
						<tr className="discount-code">
							<td>{totals.discountTitle}</td>
							<td className="text-right">{asPrice(discount)}</td>
						</tr>
					)}
					{notificationFee > 0 && (
						<tr>
							<td>{t.notificationFee}</td>
							<td className="text-right">{asPrice(notificationFee)}</td>
						</tr>
					)}
					{letterFee > 0 && (
						<tr>
							<td>{t.letterFee}</td>
							<td className="text-right">{asPrice(letterFee)}</td>
						</tr>
					)}
					{!ui.priceWithVat && (
						<tr>
							<td>{t.vat}</td>
							<td className="text-right">{asPrice(vat)}</td>
						</tr>
					)}
					<tr className="big">
						<td>
							<b>{t.totalIncVatHeading}</b>
						</td>
						<td className="text-right">
							<b>{asPrice(total)}</b>
						</td>
					</tr>
				</tbody>
			</Table>
		</div>
	);
};
